import { ArrowLeft } from 'lucide-react';
import { useChannels } from '../../../hooks/queries/useMessaging';
import { useSidecarStore } from '../../../store/useSidecarStore';
import { ChannelView } from '../ChannelView';
import { SidecarHeaderActions } from './SidecarHeaderActions';

interface Props {
  channelId: string;
  /** Split layout: list stays visible, no back chrome. */
  hideBack?: boolean;
}

export function SidecarPanelChannel({ channelId, hideBack = false }: Props) {
  const backToList = useSidecarStore((s) => s.backToList);
  const { data: channels = [] } = useChannels();
  const channel = channels.find((c) => c.id === channelId) ?? null;

  if (!channel) {
    return (
      <>
        {!hideBack && (
          <header className="flex items-center justify-between px-3 py-2 border-b border-neutral-200 flex-shrink-0">
            <div className="flex items-center gap-2">
              <button onClick={backToList} className="p-1 rounded hover:bg-neutral-100">
                <ArrowLeft className="w-3.5 h-3.5" />
              </button>
              <span className="text-sm text-cime-text-muted">Canal introuvable</span>
            </div>
            <SidecarHeaderActions />
          </header>
        )}
        <div className="flex-1 flex items-center justify-center text-xs text-cime-text-muted">
          Ce canal n'est plus accessible.
        </div>
      </>
    );
  }

  return (
    <>
      {!hideBack && (
        <header className="flex items-center justify-between px-2 py-1.5 border-b border-neutral-200 flex-shrink-0">
          <button
            onClick={backToList}
            title="Retour"
            className="p-1 rounded hover:bg-neutral-100 text-cime-text-muted hover:text-cime-primary"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
          </button>
          <SidecarHeaderActions />
        </header>
      )}

      <div className="flex-1 min-h-0 overflow-hidden">
        <ChannelView channel={channel} />
      </div>
    </>
  );
}
